import React, { useEffect, useState } from 'react';
import { Typography, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FetchUserData from './components/fetchUserData';

function AiLanding() {
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
   
    const { userData } = FetchUserData({ setLoading, setShowError });

    useEffect(() => {
        if (userData) {
            setLoading(true);
            //console.log("userData: ", userData);
            fetch(apiUrl + '/api/check_optin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ userData: userData }, null, 2),
            })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                //console.log("data: ", data);
                const parsedData = JSON.parse(data); 
                //console.log("parsedData:", parsedData);
                if (parsedData["response"] === "True")  { 
                    navigate('/aiassist_optout', { state: { userData } });
                } else {
                    navigate('/aiassist_optin', { state: { userData } });
                }
            })
            .catch((error) => {
                console.error('Error setting data from /api/check_optin:', error);
                setLoading(false);
            });
        }
    }, [apiUrl, navigate, userData]);

    return (
        <Grid container spacing={2} rowSpacing={2}>
            <Grid item xs={2} />  
            <Grid item xs={8} alignItems="center">
                {loading && !showError ? (
                    <>
                        <Typography variant="h5" align="center">Loading...</Typography>
                        <div style={{ textAlign: 'center' }}>
                            <CircularProgress />
                        </div>
                    </>
                    ) : showError ? (
                        <Typography variant="h5" align="center">Error Loading</Typography>
                    ) : ( 
                        <div /> 
                    )
                }
            </Grid>
            <Grid item xs={2} />
        </Grid>
    );
}

export default AiLanding;